import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { store } from "./index";

const StoreProvider = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};
StoreProvider.propTypes = {
  children: PropTypes.node,
};

StoreProvider.defaultProps = {
  children: null,
};

export default StoreProvider;
